<template>
    <div>
        <div class="flex_b pad14" id="toolH">
            <div class="flex">
                <el-select style="width: 145px" @change="changeState"  class="marr4" v-model="i_state" size="small"  filterable placeholder="">
                    <el-option
                            v-for="item in stateData"
                            :key="item.i_state"
                            :label="item.vc_name"
                            :value="item.i_state">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" @change="changeCom" @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="small" clearable filterable :placeholder="$t('saleInvoicing_please_select_a_trading_company')">
                    <el-option
                            v-for="item in compsData"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" @change="changetype" class="marr4" v-model="i_type" size="small" filterable :placeholder="$t('saleInvoicing_please_select')">
                    <el-option
                            v-for="item in typeList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" class="marr4" @change="changely" @clear="clearsearch('ly')" v-model="i_invoice_source" size="small" clearable filterable :placeholder="$t('saleInvoicing_source')">
                    <el-option
                            v-for="item in lyList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-date-picker
                        v-if="i_state!=0"
                        style="width: 220px"
                        class="marr4"
                        size="small"
                        v-model="valuetime"
                        @change="getTimes"
                        :clearable="false"
                        type="daterange"
                        :range-separator="$t('saleInvoicing_to')"
                        :start-placeholder="$t('saleInvoicing_start_date')"
                        :end-placeholder="$t('saleInvoicing_end_date')">
                </el-date-picker>
                <el-input
                        style="width: 220px"
                        class="marr4"
                        size="small"
                        :placeholder="$t('saleInvoicing_search')"
                        clearable
                        v-model="vc_search">
                </el-input>
                <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
                <el-button v-if="i_state==0" :class="baseerp+'btn'"  size="small" type="primary" @click="addKp">{{$t('saleInvoicing_add_invoicing')}}</el-button>
<!--                <el-button v-if="i_state==0" :class="baseerp+'btn'"  size="small" type="primary" @click="editRow">编辑</el-button>-->
<!--                <el-button v-if="i_state==0" :class="baseerp+'btn'"  size="small" type="primary" @click="saveRows">保存</el-button>-->
                <el-button v-if="i_state==4" :class="baseerp+'btn'"  size="small" type="primary" @click="setFp(null,'pl',4)">{{$t('saleInvoicing_batch_invoice_registration')}}</el-button>
            </div>
        </div>
        <div v-loading="loading">
            <el-table
                    border
                    v-if="showTable"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @select="getselect"
                    @selection-change="handleSelectionChange"
                    @select-all="handleSelectAll"
                    :class="{'hide-header-selection':i_state == 3}"
                    size="mini"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-selection-row="true"
                    :highlight-current-row="true"
                    :row-class-name="rowClassName"
                    @row-click="rowClick">
                <el-table-column
                        v-if="i_state==0||i_state==1||i_state==3||i_state==4"
                        type="selection"
                        :selectable="checkSelectable"
                        width="45">
                </el-table-column>
                <el-table-column
                        :label="$t('saleInvoicing_serial_number')"
                        type="index"
                        width="55">
                </el-table-column>
                <el-table-column
                        prop="vc_khname"
                        :label="$t('saleInvoicing_customer')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="i_invoice_source"
                        :label="$t('saleInvoicing_invoice_source')"
                        min-width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.i_invoice_source==1?$t('saleInvoicing_shushuiyun'):(scope.row.i_invoice_source==2?$t('saleInvoicing_offline'):(scope.row.i_invoice_source==3?$t('saleInvoicing_south_north'):''))}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="i_title_type"
                        :label="$t('saleInvoicing_invoice_title')"
                        show-overflow-tooltip
                        min-width="120">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.edit" style="width: 80px"  @change="changeTt"  class="marr4" v-model="scope.row.i_title_type" size="mini" filterable >
                            <el-option
                                    v-for="item in titleType"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.i_title_type==1?$t('saleInvoicing_enterprise'):$t('saleInvoicing_individual')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_invoice_type"
                        :label="$t('saleInvoicing_invoice_type')"
                        show-overflow-tooltip
                        min-width="170">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.edit" style="width: 140px" @change="changeInvoice(scope.row)" class="marr4" v-model="scope.row.i_invoice_type" size="mini" filterable >
                            <el-option
                                    v-for="item in kplxData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_invoice_type}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="typeTxt"
                        :label="$t('saleInvoicing_invoice_leixing')"
                        width="80"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        v-if="i_state==-1"
                        prop="vc_relateinvoice_code"
                        :label="$t('saleInvoicing_associated_invoice_number')"
                        show-overflow-tooltip
                        min-width="155">
                </el-table-column>
                <el-table-column
                        prop="vc_xcode"
                        :label="$t('saleInvoicing_sales_number')"
                        show-overflow-tooltip
                        min-width="155">
                </el-table-column>
                <el-table-column
                        prop="vc_pzname"
                        :label="$t('form_product_name')"
                        show-overflow-tooltip
                        min-width="100">
                </el-table-column>
                <!--<el-table-column
                        prop="vc_pz_invoicename"
                        label="开票品名"
                        show-overflow-tooltip>
                </el-table-column>-->
                <el-table-column
                        prop="vc_kpname_sell"
                        :label="$t('saleInvoicing_invoice_item_name')"
                        show-overflow-tooltip
                        min-width="110">
                    <template slot-scope="scope" >
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_kpname_sell">
                        </el-input>
                        <span v-else>{{scope.row.vc_kpname_sell}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_pzspecs"
                        :label="$t('saleInvoicing_specification_model')"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_kpbzstyle_sell"
                        :label="$t('saleInvoicing_invoice_specifications')"
                        show-overflow-tooltip
                        width="140">
                    <template slot-scope="scope" >
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_kpbzstyle_sell">
                        </el-input>
                        <span v-else>{{scope.row.vc_kpbzstyle_sell}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="f_num"
                        :label="$t('saleInvoicing_quantity')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_kpnum_sell"
                        :label="$t('saleInvoicing_invoice_quantity')"
                        show-overflow-tooltip
                        width="125"
                        align="right">
                    <template slot-scope="scope" >
                        <el-input-number v-if="scope.row.edit" @change="changenum(scope.row)" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"  size="mini" v-model="scope.row.f_kpnum_sell" ></el-input-number>
                        <span v-else>{{scope.row.f_kpnum_sell}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        width="55"
                        prop="vc_unit"
                        :label="$t('saleInvoicing_unit')"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_kpunit_sell"
                        :label="$t('saleInvoicing_billing_entity')"
                        show-overflow-tooltip
                        width="128">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.edit" style="width: 100px" @focus="getUnits(scope.row)"  @change="changeData(scope.row)"  class="marr4" v-model="scope.row.vc_kpunit_sell" size="mini" clearable filterable placeholder="请选择开票单位">
                            <el-option
                                    v-for="item in unitData"
                                    :key="item.vc_unitsconvert"
                                    :label="item.vc_unitsconvert"
                                    :value="item.vc_unitsconvert">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_kpunit_sell}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="f_price"
                        :label="$t('saleInvoicing_order_unit_price')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_kpprice_sell"
                        :label="$t('saleInvoicing_unit_price_on_invoice')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_amount"
                        :label="$t('saleInvoicing_kaipiao_amount')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_price_notax"
                        :label="$t('saleInvoicing_unit_price_excluding_tax')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_amount_notax"
                        :label="$t('saleInvoicing_tax_exempt_amount')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_sl"
                        :label="$t('saleInvoicing_tax_rate')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_amount_tax"
                        :label="$t('saleInvoicing_tax_amount')"
                        show-overflow-tooltip
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="vc_note"
                        :label="$t('saleInvoicing_invoice_remarks')"
                        show-overflow-tooltip
                        min-width="80">
                </el-table-column>
                <el-table-column
                        prop="vc_gsname"
                        :label="$t('saleInvoicing_seller')"
                        show-overflow-tooltip
                        min-width="120">
                </el-table-column>
                <el-table-column
                        prop="vc_kduname"
                        :label="$t('saleInvoicing_business')"
                        show-overflow-tooltip
                        min-width="85">
                </el-table-column>
                <!--<el-table-column
                        prop="vc_lruname"
                        label="开单人"
                        show-overflow-tooltip>
                </el-table-column>-->
                <el-table-column
                        prop="vc_creditcode"
                        :label="$t('saleInvoicing_customer_taxpayer_identification_number')"
                        show-overflow-tooltip
                        min-width="120">
                </el-table-column>
                <el-table-column
                        prop="vc_adress"
                        :label="$t('saleInvoicing_address')"
                        show-overflow-tooltip
                        min-width="120">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_address">
                        </el-input>
                        <span v-else style="margin-left: 10px">{{ scope.row.vc_address}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_tel"
                        :label="$t('saleInvoicing_telephone')"
                        show-overflow-tooltip
                        min-width="120">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_tel">
                        </el-input>
                        <span v-else style="margin-left: 10px">{{scope.row.vc_tel }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="address"
                        :label="$t('saleInvoicing_bank_of_deposit')"
                        show-overflow-tooltip
                        min-width="120">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_bank">
                        </el-input>
                        <span v-else style="margin-left: 10px">{{ scope.row.vc_bank}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="address"
                        :label="$t('saleInvoicing_bank_account_number')"
                        show-overflow-tooltip
                        min-width="150">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_bank_account">
                        </el-input>
                        <span v-else style="margin-left: 10px">{{scope.row.vc_bank_account }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_email"
                        :label="$t('saleInvoicing_email')"
                        show-overflow-tooltip
                        min-width="170">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_email">
                        </el-input>
                        <span v-else style="margin-left: 10px">{{scope.row.vc_email }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_note"
                        :label="$t('form_notes')"
                        show-overflow-tooltip
                        width="100">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_note">
                        </el-input>
                        <span v-else style="margin-left: 10px">{{scope.row.vc_note }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_lruname"
                        :label="$t('saleInvoicing_applicant')"
                        show-overflow-tooltip
                        min-width="90">
                </el-table-column>
                <el-table-column
                        prop="dt_applytime"
                        :label="$t('saleInvoicing_application_time')"
                        show-overflow-tooltip
                        min-width="120">
                </el-table-column>
                <el-table-column
                        prop="i_state"
                        :label="$t('saleInvoicing_billing_status')"
                        show-overflow-tooltip
                        min-width="90">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.i_state==0?$t('saleInvoicing_to_be_submitted'):(scope.row.i_state==1?$t('saleInvoicing_submitted'):(scope.row.i_state==2?$t('saleInvoicing_invoiced'):(scope.row.i_state==3?$t('saleInvoicing_under_review'):(scope.row.i_state==-1?$t('saleInvoicing_redemption_completed'):'')))) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="i_state==0||i_state==1"
                        prop="vc_apinote"
                        :label="$t('saleInvoicing_reason_for_failure')"
                        show-overflow-tooltip
                        min-width="80">
                </el-table-column>
                <el-table-column
                        prop="dt_invoicetime"
                        :label="$t('saleInvoicing_invoice_time')"
                        show-overflow-tooltip
                        min-width="120">
                </el-table-column>
                <el-table-column
                        prop="vc_invoice_code"
                        :label="$t('saleInvoicing_invoice_code')"
                        show-overflow-tooltip
                        min-width="100">
                </el-table-column>
                <el-table-column
                        v-if="i_state==2||i_state==-1||i_state==4"
                        prop="vc_file"
                        :label="$t('saleInvoicing_attachment')"
                        show-overflow-tooltip
                        min-width="55px">
                    <template slot-scope="scope">
                        <a v-for="item in scope.row.files" :href="file_root+item.vc_mainfile_newname" target="_blank">
                            <i class="el-icon-paperclip" v-show="item.vc_mainfile_newname"></i>
                        </a>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('saleInvoicing_operation')" :width="i_state==4?140:70" v-if="i_state!=2&&i_state!=-1">
                    <template slot-scope="scope">
                        <el-button size="mini" style="color: red"
                                   type="text"
                                   @click="handleDelete(scope.$index, scope.row)">{{i_state==4?$t('saleInvoicing_withdrawal_of_application'):$t('saleInvoicing_delete')}}</el-button>
                        <el-button v-if='i_state==4' size="mini"
                                   type="text"
                                   @click="setFp(scope.row,'one',4)">{{$t('saleInvoicing_register_the_invoice')}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('saleInvoicing_operation')" width="70" v-if="i_state==2">
                    <template slot-scope="scope" v-if="scope.row.i_invoice_source!=1">
                        <el-button size="mini"
                                   type="text"
                                   @click="setFp(scope.row,'one',2)">{{$t('saleInvoicing_write-off_in_red')}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('saleInvoicing_send_business')" width="80"  >
                    <template slot-scope="scope">
                        <el-button size="mini" style="color: red"
                                   type="text" v-if="i_state==2"
                                   @click="sendMessage(scope.$index, scope.row)">{{$t('saleInvoicing_resend')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    v-if="i_state==2||i_state==-1"
                    class="fr mrr9 padT6"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :total="tableTotal">
            </el-pagination>
            <div class="flex_b alc mar9"  v-else>
                <div>
                    {{$t('saleInvoicing_selected')+ ' '+multipleSelection.length+' '+$t('saleInvoicing_item')}}
                </div>
                <div class="flex alc">
                    <div class="marr4">
                        <div style="color: #9e9e9e;font-size: 12px">{{$t('saleInvoicing_total_invoice_amount')}}</div>
                        <div>{{totalPrice}}</div>
                    </div>
                    <el-button :class="baseerp+'btn'" v-if="i_state==0||i_state==3" @click="kpsubmit('1')"  size="small" type="primary">{{$t('saleInvoicing_submit_the_invoice')}}</el-button>
                    <el-button :class="baseerp+'btn'" v-if="i_state==1" @click="kpsubmit('2')"  size="small" type="primary">{{$t('saleInvoicing_invalid_submission')}}</el-button>
                </div>
            </div>
        </div>
        <!--dialog-->
        <!--<div class="cgdia">-->
            <el-dialog
                    :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                    :class="baseerp+'div'"
                    top="5vh"
                    width="90%"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible"
                    :append-to-body="true">
                <fore-kp :Data="Data" @cancelDialog="cancelDialog" @bbSheet="bbSheet"></fore-kp>
            </el-dialog>
        <!--</div>-->
        <div>
            <reportdialog  ref="mydialog"  ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="$t('saleInvoicing_register_the_invoice')"
                :visible.sync="dialogVisible_fpcnew"
                :close-on-click-modal="false"
                @close="confirmFp(type='back')"
                v-if="dialogVisible_fpcnew"
                :append-to-body="true">
            <fpc-listnew @confirm="confirmFp" :fpData="fpData"></fpc-listnew>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "./api";
    import {file_root} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import foreKp from "./foreKp";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import fpcListnew from "./fpcListnew";
    export default {
        name: 'saleInvoicing',
        components:{
            foreKp,
            eDialog,
            reportdialog,
            fpcListnew
        },
        data() {
            return {
                activePage:"report/res/spread.vue",
                i_invoice_source:0,
                lyList:[{i_id:1,vc_name:this.$t('saleInvoicing_shushuiyun')},{i_id:2,vc_name:this.$t('saleInvoicing_offline')},{i_id:3,vc_name:this.$t('saleInvoicing_south_north')},{i_id:0,vc_name:this.$t('saleInvoicing_all')}],
                titleType:[{i_id:1,vc_name:this.$t('saleInvoicing_enterprise')},{i_id:2,vc_name:this.$t('saleInvoicing_individual')}],
                kpData:[],
                kplxData:[],
                copyvaildnum:0,
                unitData:[],
                showTable:true,
                file_root:"",
                baseerp:"",
                mid:0,
                loading:true,
                tableHeight:0,
                title:this.$t('saleInvoicing_list_of_pending_invoices'),
                cshtitle:this.$t('saleInvoicing_list_of_invoiced_items'),
                dialogVisible:false,
                cshdialogVisible:false,
                dialogVisible_fpcnew:false,
                fpData:{},
                Data:{},
                cshData:{},
                totalPrice:0,
                stateData:[
                    { i_state:0,vc_name:this.$t('saleInvoicing_to_be_submitted')},
                    { i_state:1,vc_name:this.$t('saleInvoicing_submitted')},
                    { i_state:2,vc_name:this.$t('saleInvoicing_invoiced')},
                    { i_state:3,vc_name:this.$t('saleInvoicing_under_review')},
                    { i_state:-1,vc_name:this.$t('saleInvoicing_redemption_completed')},
                    { i_state:4,vc_name:this.$t('saleInvoicing_offline_pending_invoicing')},
                ],
                i_state:0,
                compsData:[],
                companyName:'',
                companyId:0,
                vc_search:"",
                pageSize:999,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                tableData: [],
                multipleSelection: [],
                i_type:1,
                typeList:[{i_id:1,vc_name:this.$t('saleInvoicing_blue_text')},{i_id:2,vc_name:this.$t('saleInvoicing_scarlet_letter')}]
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            i_state(){
                // console.log(this.i_state,'i_state')
                this.refreshTable();
            },
            vc_unit(){
                //console.log(this.vc_unit,'vc_unit')
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.file_root = file_root;
            this.baseerp=baseerp;
            this.invoicetype();
            this.getList();
            //this.getfMou();
            this.getCompanyList();
            this.$nextTick(function () {
                this.onResize();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                // console.log(n.h,this.tableHeight)
            },
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
                const otherHeight =230;
                this.tableHeight = window.innerHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
            },
            handleSelectAll(selection) {
                if (this.i_state == 3) {
                    this.$refs.multipleTable.clearSelection();
                    this.$message({
                        message:this.$t('saleInvoicing_the_current_status_is_under_application_one_click_selection_is_prohibited_please_check_each_row_requiring_action_individually') ,
                        type: 'warning',
                        duration: 2000
                    });
                }
            },
            checkSelectable(row){
                if(this.i_state==3){
                    return row.isovertime !== 0;
                }else{
                    return true;
                }
            },
            setFp(val,type,state ){
                let i_invoicetype = null;
                if(this.companyId==0){
                    this.$message.error(this.$t('saleInvoicing_please_select_trading_company_first'));
                    return;
                }
                if(this.multipleSelection.length==0&&type=='pl'){
                    this.$message.error(this.$t('saleInvoicing_please_select_the_invoicing_order'));
                    return;
                }
                let kpids=[];
                if(type=='one'){
                    kpids.push(val.i_id);
                }
                if(type=='pl'){
                    console.log(this.multipleSelection,'this.multipleSelection')
                    const gsidSet = new Set(this.multipleSelection.map(item => item.i_khid));
                    console.log(gsidSet.size,'gsidSet')
                    if (gsidSet.size > 1) {
                        this.$message.warning(this.$t('saleInvoicing_please_select_data_of_same_customer'));
                        return;
                    }
                    this.multipleSelection.map(item=>kpids.push(item.i_id));
                }
                if(state&&state==2){
                    i_invoicetype = 2 //chonghong hongzi
                }else if(state&&state==4){
                    i_invoicetype = 1
                }
                this.fpData={kpids:kpids,i_invoicetype:i_invoicetype};
                this.dialogVisible_fpcnew=true
            },
            confirmFp({type,data}){
                //console.log('type',type,'data',data)
                this.dialogVisible_fpcnew=false;
                if(type=='save'){
                    this.i_state=4;
                    this.currentPage=1;
                    this.pageSize=999;
                    this.tableData=[];
                    this.dt_startdate='';
                    this.dt_enddate='';
                    this.getList();
                }
            },
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            bbSheet(arg){
                //console.log('arg',arg)
                if(arg.i_gsid==0){
                    this.$message.error(this.$t('saleInvoicing_please_select_a_company_first'));
                    return;
                }
                let loading =this.$loading({lock:true,text:this.$t('saleInvoicing_loading_data_please_wait_'),background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({
                    title:this.$t('saleInvoicing_export'),
                    parm:{
                        type:'invoiceApplyRpt',
                        mid:this.$route.meta.mid,
                        arg:{
                            "i_gsid": arg.i_gsid,
                            "vc_search": arg.vc_search,
                            'dt_startdate':arg.dt_startdate,
                            'dt_enddate':arg.dt_enddate,
                        }},
                    w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })
            },
            changeTt(e){
                //console.log('e',e)
                this.i_title_type=e;
                this.kplxData = [];
                this.kplxData = this.i_title_type==2?this.kpData.filter(kp=>kp.i_isspec==0):this.kpData
                //console.log(this.kplxData ,'this.kplxData--- ')
            },
            //开票类型
            async invoicetype(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.invoicetype(param);
                if (res.code == 1) {
                    this.kpData = res.data.list;
                    this.kplxData = this.kpData;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changenum(e){
                //console.log('e',e.f_kpnum_sell)
                if(e.f_kpnum_sell>this.tableData[e.index].f_validnum||e.f_kpnum_sell==0){
                    this.$message.error(this.$t('saleInvoicing_the_edited_invoice_quantity_must_not_exceed_the_original_invoice_quantity'));
                    this.tableData[e.index].f_kpnum_sell =this.tableData[e.index].f_validnum;
                    this.tableData[e.index].f_num = this.tableData[e.index].f_validnum / 1
                    this.$set(this.tableData,e.index,e)
                }else{
                    this.tableData[e.index].f_kpnum_sell = e.f_kpnum_sell;
                    let price = this.tableData[e.index].f_kpnum_sell * this.tableData[e.index].f_kpprice_sell;
                    this.tableData[e.index].f_amount = Math.round(parseFloat(price) * 100) / 100;
                    this.tableData[e.index].f_num = this.tableData[e.index].f_kpnum_sell / this.tableData[e.index].f_bl
                    /*let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                    this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;*/
                    this.$set(this.tableData,e.index,e)
                }
                //console.log( this.tableData[e.index].f_num,' this.tableData[e.index].f_num')

            },
            rowClick(row){
                /*if (row.edit) {
                    this.chooseRow = row
                    this.chooseIndex = row.index
                }
                console.log(row, row.index,'row')*/
            },
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            saveRows(){
                if(this.multipleSelection.length!=0&&this.Edit){
                    this.Edit=false;
                    //console.log(this.multipleSelection)
                    //return;
                    this.updInvoice()
                }else{
                    this.$message.warning(this.$t('saleInvoicing_please_edit_and_save_after'))
                }

            },
            //批量编辑待提交
            async updInvoice(){
                this.loading=true;
                let param={
                    updList:this.multipleSelection,
                };
                //return;
                let res=await API.updInvoice(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            editRow(){
                //console.log(this.Edit)
                if(this.multipleSelection.length!=0){
                    this.Edit=!this.Edit;
                    //console.log(this.multipleSelection)
                    this.multipleSelection.map(item=>{
                        this.tableData[item.index].edit=true
                    })
                    if(!this.Edit){
                        this.getList();
                    }
                    //this.$set(this.tableData,this.chooseRow.index,this.chooseRow)
                }else{
                    this.$message.warning(this.$t('saleInvoicing_please_select_the_data_to_edit'))
                }

            },
            changeInvoice(e){
                //console.log(this.kplxData,'this.kplxData');
                //console.log(e,'e');
                this.tableData[e.index].i_invoice_type=e.i_invoice_type;
                let choo = this.kplxData.filter(item=>{
                    return item.i_id == e.i_invoice_type
                });
                //console.log(choo,'choo');
                if(choo.length>0){
                    //this.i_isspec=choo[0].i_isspec;
                    this.tableData[e.index].vc_invoice_type=choo[0].vc_name;
                }else{
                    //this.i_isspec=null;
                    this.tableData[e.index].vc_invoice_type='';
                }
            },
            getUnits(row){
                //console.log(row,'22222');
                this.copyvaildnum=row.f_num;
                this.getUnitList(row.vc_unit);
            },
            changeData(e){
                //console.log(e.vc_kpunit_sell);
                //this.formData.vc_kpunit_sell=e;
                if(this.unitData.length!=0){
                    let choo = this.unitData.filter(item=>{
                        return item.vc_unitsconvert == e.vc_kpunit_sell
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].f_bl=choo[0].f_bl;
                        let f_kpprice_sell = this.tableData[e.index].f_price / choo[0].f_bl;
                        //console.log('f_kpprice_sell',f_kpprice_sell)
                        this.tableData[e.index].f_kpprice_sell = Math.round(parseFloat(f_kpprice_sell) * 100) / 100;
                        let validnum =0;
                        validnum=this.copyvaildnum*choo[0].f_bl;
                        //console.log('validnum',validnum)
                        this.tableData[e.index].f_validnum =validnum;
                        this.tableData[e.index].f_kpnum_sell=this.tableData[e.index].f_validnum;

                        //let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                    }else{
                        this.tableData[e.index].f_bl=1;
                        this.tableData[e.index].f_kpprice_sell = this.tableData[e.index].f_price*1;
                        this.tableData[e.index].f_validnum =this.copyvaildnum;
                        this.tableData[e.index].f_kpnum_sell=this.copyvaildnum;
                        this.tableData[e.index].vc_kpunit_sell=this.tableData[e.index].vc_unit;
                        //let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }

            },
            //单位换算
            async getUnitList(vc_unit){
                let param = {
                    i_mid:this.mid,
                    vc_originunit:vc_unit,
                };
                let res = await API.getUnitList(param);
                if (res.code == 1) {
                    this.unitData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            kpsubmit(val){
                // console.log(this.multipleSelection,'this.multipleSelection')
                if(this.multipleSelection.length==0){
                    this.$message.error(this.$t('saleInvoicing_please_select_the_invoicing_order'));
                    return;
                }else{
                    if(val=='1'){
                        this.submit(this.multipleSelection)
                    }
                    if(val=='2'){
                        this.cancelsubmit(this.multipleSelection)
                    }
                }


            },
            //删除提交
            async cancelsubmit(id){
                this.disabled=true;
                this.loading=true;
                let alist=[];
                    id.map(item=>{
                        alist.push(item.i_id);
                    })
                let param={
                    ids:alist,
                };
                //console.log(param)
                //return
                let res=await API.cancelsubmit(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.getList();
                    this.$message.error(res.message);
                }
            },
            //提交
            async submit(id){
                this.disabled=true;
                this.loading=true;
                let alist=[];
                    id.map(item=>{
                        alist.push(item.i_id);
                    })
                let param={
                    ids:alist,
                };
                //console.log(param)
                //return
                let res=await API.submit(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.getList();
                    this.$message.error(res.message);
                }
            },
            cshFun(){
                this.cshData={
                    "i_gsid": this.companyId,
                };
                this.cshdialogVisible=true;
            },
            addKp(){
                if(this.companyId==0){
                    this.$message.error(this.$t('saleInvoicing_please_select_a_company_first'));
                    return;
                }
                this.Data={
                    "i_gsid": this.companyId,
                    'maxDialogHeight':this.maxDialogHeight,
                };
                this.dialogVisible=true;
            },
            cancelDialog(val){
                //console.log('val',val);
                this.Data={};
                this.dialogVisible=false;
                if(val=='new'){
                    this.i_state=0;
                    this.currentPage=1;
                    this.pageSize=999;
                    this.tableData=[];
                    this.dt_startdate='';
                    this.dt_enddate='';
                    this.getList();
                }
            },
            cshcancelDialog(val){
                //console.log('val',val);
                this.cshData={};
                this.cshdialogVisible=false;
                if(val=='new'){
                    this.i_state=0;
                    this.currentPage=1;
                    this.pageSize=999;
                    this.tableData=[];
                    this.dt_startdate='';
                    this.dt_enddate='';
                    this.getList();
                }
            },
            sendMessage(index, row){
                this.$confirm(this.$t('saleInvoicing_isresend'),this.$t('saleInvoicing_hint'),{
                    confirmButtonText:this.$t('saleInvoicing_continue'),
                    cancelButtonText:this.$t('saleInvoicing_cancel'),
                    type:'warning'
                }).then(async()=>{
                    this.sendMsg(row.vc_invoice_code)
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:this.$t('saleInvoicing_cancelled')
                    })
                })
            },
            handleDelete(index, row){
                this.$confirm(this.$t('saleInvoicing_should_this_data_be_deleted'),this.$t('saleInvoicing_hint'),{
                    confirmButtonText:this.$t('saleInvoicing_continue'),
                    cancelButtonText:this.$t('saleInvoicing_cancel'),
                    type:'warning'
                }).then(async()=>{
                    this.saveForm(row.i_id)

                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:this.$t('saleInvoicing_cancelled')
                    })
                })
            },
            //重发
            async sendMsg(val){
                this.disabled=true;
                this.loading=true;
                let param={
                    vc_invoice_code:val
                };
                let res=await API.sendMsg(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    // this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //保存
            async saveForm(id){
                let alist=[];
                alist.push(id);
                this.disabled=true;
                this.loading=true;
                let param={
                    delSub:alist,
                    list:[],
                };
                let res=await API.saveInvoice(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            getselect(val,row){
                //console.log(val,row);

            },
            handleSelectionChange(val) {
                if(this.i_state==0||this.i_state==1||this.i_state==4||this.i_state==3){
                    // console.log(val,'val')
                    this.multipleSelection = val;
                    //let totalP = 123.126846523;
                    let totalP = 0;
                    val.map(item=>{
                        totalP += item.f_amount
                    });
                    this.totalPrice = Math.round(parseFloat(totalP) * 100) / 100;
                }

            },
            //获取交易公司
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.mid,'this.m!!!!!!!!!')
                let param = {
                    vc_search:'',
                    page_count:1,
                    page_size:999,
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changely(e){
                this.i_invoice_source=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changeCom(e){
                // console.log(e);
                this.companyId=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changetype(e){
                // console.log(e);
                this.i_type=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changeState(e){
                // console.log(e,'?????');
                this.totalPrice=0;
                this.i_state=e;
                if(this.i_state==0||this.i_state==1||this.i_state==4||this.i_state==3){
                    this.currentPage=1;
                    this.pageSize=999;
                    this.dt_startdate='';
                    this.dt_enddate='';
                    //this.getList();
                }else{
                    this.currentPage=1;
                    this.pageSize=30;
                    //this.getfMou();
                }
                this.$nextTick(()=>{
                    this.getfMou();
                })

            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";

                }else if(type=='sou'){
                    this.vc_search=""
                }else if(type=='lx'){
                    this.vc_search=""
                }else if(type=='ly'){
                    this.i_invoice_source=0
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    'i_state':this.i_state,
                    "i_gsid": this.companyId,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'dt_startdate':this.i_state==0?'':this.dt_startdate,
                    'dt_enddate':this.i_state==0?'':this.dt_enddate,
                    i_type:this.i_type,
                    i_invoice_source:this.i_invoice_source,
                };
                // console.log('调接口',this.vc_search,this.companyId);
                //return;
                if(this.i_state==2||this.i_state==-1){
                    var res = await API.queryInvoicedAndRedInvoices(param);
                }else{
                    var res = await API.listInvoice(param);
                }
                if (res.code==1){
                    if(this.i_state==2||this.i_state==-1){
                        this.loading=false;
                        this.Edit=false;
                        res.data.map(item=>{
                            item.edit=false;
                            let files=[];
                            //let arr = item.vc_file.split(';')
                            let arr = item.vc_file ? item.vc_file.split(';') : [];
                            arr.map((subitem,subindex)=>{
                                let map={}
                                map.vc_mainfile_newname=subitem;
                                //map.vc_filename=item.vc_fpcode+'_'+subindex;
                                files.push(map)
                            })
                            item.files=files;
                        })
                        this.tableData=res.data;
                        this.tableTotal=res.total;
                        this.setDialogHeight();
                        window.addEventListener('resize', this.setDialogHeight);
                    }else{
                        this.loading=false;
                        this.Edit=false;
                        res.data.list.map(item=>{
                            item.edit=false;
                            let files=[];
                            //let arr = item.vc_file.split(';')
                            let arr = item.vc_file ? item.vc_file.split(';') : [];
                            arr.map((subitem,subindex)=>{
                                let map={}
                                map.vc_mainfile_newname=subitem;
                                //map.vc_filename=item.vc_fpcode+'_'+subindex;
                                files.push(map)
                            })
                            item.files=files;
                        })
                        this.tableData=res.data.list;
                        this.tableTotal=res.data.total;
                        this.setDialogHeight();
                        window.addEventListener('resize', this.setDialogHeight);
                    }

                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
        }
    }
</script>
<style  lang="scss" scoped>
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }

    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>
